import { Article } from "@faire/help-center-utils/articles";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { getRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES } from "@faire/web--source/common/consts/THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";

import { useLoggedOutRetailerNodes } from "../../hooks/useLoggedOutRetailerNodes";

const DEFAULT_REGION = "USA";

export const useFilteredArticles = (
  articles: Article[],
  issueL2: string | undefined,
  loggedOutExperience: boolean
) => {
  const region = useRegion();
  const hcArticles = useArticles();
  const retailerNodes = useLoggedOutRetailerNodes();
  return articles.filter((article) => {
    if (
      issueL2 === retailerNodes.L2.BuyingInternational &&
      !loggedOutExperience
    ) {
      return article === hcArticles.ImportFeesAndDuties[region];
    }
    return article;
  });
};

const useRegion = () => {
  const retailerCountry = useRetailerCountry();

  if (isEuropeanCountry(retailerCountry)) {
    return "Europe";
  } else if (retailerCountry === ISO3166Alpha3.USA) {
    return "USA";
  } else if (retailerCountry === ISO3166Alpha3.CAN) {
    return "Canada";
  }

  return DEFAULT_REGION;
};

const useRetailerCountry = () => {
  const retailer = getRetailer();
  return retailer?.default_shipping_address?.country ?? retailer?.country;
};

const isEuropeanCountry = (country: string | undefined) => {
  return THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES.map(String).includes(
    country ?? ""
  );
};
